import { getEnv } from '../env';
import params from '../params';

const fetchData = async () => {

    const { cheadKey } = params();

    if (!cheadKey) {
        return
    }

    const { env } = getEnv();

    const fetchUrl = env === 'localhost' ? `http://localhost:4200/chathead?key=${cheadKey}` : env === 'staging' ? `https://tvperformer.webdev.staging.hydrahub.io/chathead?key=${cheadKey}` : `https://cache.jerkmate.tv/chathead?key=${cheadKey}`

    let data = await fetch(fetchUrl)
    data = await data?.json()

    if (data?.key) {
        return data
    }

}

export default fetchData